import { PSApplication } from '../components/app/PSApplication'
import { DataType } from '../types/DataType'
import { ConstructorArgs } from '../types/models'
import { Booking } from './Booking'
import { Order } from './Order'
import { ReviewBase } from './ReviewBase'
import { FKType } from './SQLBuilder'
import { User } from './User'

type ReviewConstructorArgs = ConstructorArgs<() => Review>

export class Review extends ReviewBase {
    readonly recordType = 'review'

    sentToGoogle: boolean = false

    constructor(data?: Partial<ReviewConstructorArgs>) {
        super(data)
        if (!data) {
            this.owner = PSApplication.me()
            return
        }

        this.sentToGoogle = data.sent_to_google ?? false
    }

    clone(overrides?: Partial<ReviewConstructorArgs>): Review {
        return new Review({ ...this.serializeForClone(), ...overrides })
    }

    get reviewerName(): string {
        return this.client?.name ?? ''
    }

    get responderName(): string {
        return this.responder?.name ?? ''
    }

    jsonObject() {
        const result = super.jsonObject()
        result['owner'] = this.owner?.id
        result['client'] = this.client?.id
        result['rating'] = this.rating
        result['memo'] = this.memo
        if (this.booking) result['booking'] = this.booking.id
        if (this.order) result['order'] = this.order.id
        if (this.sentToGoogle) result['sent_to_google'] = true
        return result
    }

    static fk: FKType = {
        users: ['owner', 'client', 'responder'],
        bookings: ['booking'],
        orders: ['order'],
    }

    static dataType(): DataType {
        return 'reviews'
    }

    get owner(): User | undefined {
        return this.getForeignRecord('owner', User)
    }
    set owner(owner: User | undefined) {
        this.setForeignRecord('owner', owner)
    }
    get client(): User | undefined {
        return this.getForeignRecord('client', User)
    }
    set client(client: User | undefined) {
        this.setForeignRecord('client', client)
    }
    get responder(): User | undefined {
        return this.getForeignRecord('responder', User)
    }
    set responder(responder: User | undefined) {
        this.setForeignRecord('responder', responder)
    }
    get booking(): Booking | undefined {
        return this.getForeignRecord('booking', Booking)
    }
    set booking(booking: Booking | undefined) {
        this.setForeignRecord('booking', booking)
    }
    get order(): Order | undefined {
        return this.getForeignRecord('order', Order)
    }
    set order(order: Order | undefined) {
        this.setForeignRecord('order', order)
    }
}
